export default `
fragment ParagraphSectionTitle on ParagraphSectionTitle{
  id
  uuid
  entityBundle
  title
}
`
